import { NgModule } from '@angular/core';
import { SharedModule } from '../../../../shared';
import { NgxBootstrapMultiselectModule } from 'ngx-bootstrap-multiselect';
import { TemperaturaMultiselectComponent } from './temperatura-multiselect.component';

@NgModule({
    imports: [
        SharedModule,
        NgxBootstrapMultiselectModule
    ],
    declarations: [
        TemperaturaMultiselectComponent
    ],
    exports: [
        TemperaturaMultiselectComponent
    ]
})
export class TemperaturaMultiselectModule { }
